import React from 'react';
import { Button } from '@mui/material';
import { useThemeContext } from '../contexts/ThemeContext';

/**
 * PremiumButton component that wraps MUI Button with custom premium styles.
 * 
 * @param {Object} props
 * @param {string} props.variant - 'glass' or 'green'
 * @param {string} props.icon - FontAwesome icon class (e.g. 'fas fa-filter')
 * @param {string} props.label - Button text
 * @param {string} props.className - Additional custom classes
 */
const PremiumButton = ({
  variant = 'glass',
  icon,
  label,
  onClick,
  className = '',
  ...props
}) => {
  const { mode } = useThemeContext();
  const darkTheme = mode === 'dark';

  const baseClass =
    variant === 'green' ? 'premium-button-green' :
      variant === 'blue' ? 'premium-button-blue' :
        variant === 'orange' ? 'premium-button-orange' :
          variant === 'red' ? 'premium-button-red' :
            variant === 'purple' ? 'premium-button-purple' :
              variant === 'indigo' ? 'premium-button-indigo' :
                'premium-button-glass';

  return (
    <Button
      className={`${baseClass} ${className}`}
      onClick={onClick}
      startIcon={icon ? <i className={icon}></i> : null}
      size="small"
      sx={{
        color: variant === 'glass'
          ? (darkTheme ? 'rgba(255, 255, 255, 1) !important' : '#1a1a1a')
          : undefined
      }}
      {...props}
    >{label}</Button>
  );
};

export default PremiumButton;
